import { ToolDialog, ToolSummary, ToolSearch, ToolButton, ToolEmpty, ToolFilters } from "./ToolWorkspace";
import { Sel } from "./ui/Sel";
import { useState, useEffect } from "react";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import { toast } from "../hooks/useToast";

import { fbList, fbAdd, fbUpdate, fbDelete } from "../hooks/useFirebase";
import { getUser } from "../utils/sessao";
import { limparInstagram, linkInstagram } from "../utils/contatoLoja";
import { planejarEspelho } from "../utils/clientesSite";
import { useConfirm } from "../hooks/useConfirm";

import { Inp } from "./ui/Inp";


const TIPO_CORES = {
  Novo:         "var(--pc-ui-38bdf8, #38bdf8)",
  Frequente:    "var(--pc-ui-00d4aa, #00d4aa)",
  VIP:          "var(--pc-ui-f59e0b, #f59e0b)",
  Problemático: "#ef4444",
};

const TEMPLATES = [
  { id:"aniv",    nome:"🎂 Aniversário",    msg:"Feliz aniversário, {nome}! 🎂 É um prazer ter você como cliente da Matriz 3D. Que este dia seja muito especial para você!" },
  { id:"pronto",  nome:"✅ Pedido pronto",   msg:"Olá {nome}! 🎉 Seu pedido está pronto para retirada. Entre em contato para combinar a entrega. Obrigado por escolher a Matriz 3D!" },
  { id:"novidade",nome:"🆕 Novidade",        msg:"Olá {nome}! 👋 Temos novidades incríveis na Matriz 3D. Que tal conferir nossos novos produtos e filamentos? Fique à vontade para nos chamar!" },
  { id:"promo",   nome:"🔥 Promoção",        msg:"Olá {nome}! 🔥 Promoção especial na Matriz 3D esta semana! Aproveite condições exclusivas. Entre em contato e garanta o seu!" },
  { id:"posvenda",nome:"😊 Pós-venda",       msg:"Olá {nome}! Como foi a experiência com seu pedido da Matriz 3D? Seu feedback é muito importante para continuarmos melhorando. 😊" },
  { id:"retorno", nome:"💬 Reengajamento",   msg:"Olá {nome}! Sentimos sua falta por aqui! 😊 A Matriz 3D tem novidades esperando por você. Quando quiser fazer um novo pedido, é só nos chamar!" },
];

const fmtCel = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0,2)}) ${d.slice(2)}`;
  return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
};

const fmtAniv = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 4);
  if (d.length <= 2) return d;
  return `${d.slice(0,2)}/${d.slice(2)}`;
};

function diasAtras(isoDate) {
  if (!isoDate) return null;
  return Math.floor((Date.now() - new Date(isoDate)) / 86400000);
}

export default function Clientes({ onBadgeUpdate }) {
  const empty = { nome:"", celular:"", instagram:"", aniversario:"", aceitaWhatsapp:false, tipo:"" };
  const [formOpen, setFormOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [tipoFiltro, setTipoFiltro] = useState("Todos");
  const [data,         setData]         = useState([]);
  const [form,         setForm]         = useState(empty);
  const [editId,       setEditId]       = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [busca,        setBusca]        = useState("");
  const [msgModal,     setMsgModal]     = useState(null);
  const [msgTexto,     setMsgTexto]     = useState("");
  const [templateSel,  setTemplateSel]  = useState("");
  const [enviando,     setEnviando]     = useState(false);
  const [erroMsg,      setErroMsg]      = useState("");
  const [okMsg,        setOkMsg]        = useState(false);
  const [confirmar,    modalConfirm]    = useConfirm();

  // Deeplink: cliente destacado
  let deeplinkClienteId = null;
  try {
    const dl = JSON.parse(localStorage.getItem("notif_deeplink") || "null");
    if (dl?.type === "birthday") deeplinkClienteId = dl.clienteId;
  } catch {}

  const carregar = async (silencioso=true) => {
    if (!silencioso) setLoading(true);
    try {
      let lista = await fbList("clientes");

      // Espelhar clientes cadastrados na loja online (clientes_finais) para o CRM:
      // cria os novos e leva pro CRM o que o cliente alterou em "Minha conta"
      // (nome, celular, nascimento, Instagram). Regras em utils/clientesSite.js.
      try {
        const cur = getUser();
        if (cur?.uid) {
          const cfSnap = await getDocs(collection(db, `users/${cur.uid}/clientes_finais`));
          const { criar, atualizar } = planejarEspelho(lista, cfSnap.docs.map(d => ({ id: d.id, ...d.data() })));
          for (const dados of criar) await fbAdd("clientes", dados);
          for (const { id, patch } of atualizar) await fbUpdate("clientes", id, patch);
          if (criar.length || atualizar.length) lista = await fbList("clientes");
        }
      } catch (e) {
        console.error("Erro ao espelhar clientes do site:", e);
      }

      setData(lista);
    } catch {
      // silently handled — loading stops via finally
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  useEffect(() => { carregar(false); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    if (saving) return;
    if (!form.nome.trim() || !form.celular.trim()) { toast("Preencha nome e celular!", "warning"); return; }
    // Aceita "@usuario" ou o link do perfil; guarda só o usuário.
    const instagram = limparInstagram(form.instagram);
    if (form.instagram.trim() && !instagram) { toast("Instagram inválido. Use só o usuário, ex.: @sualoja", "warning"); return; }
    const dados = { ...form, instagram };
    setSaving(true);
    try {
    if (editId) {
      await fbUpdate("clientes", editId, dados);
      setEditId(null);
    } else {
      await fbAdd("clientes", { ...dados, criadoEm: new Date().toISOString() });
    }
    setForm(empty); setFormOpen(false);
    carregar(); toast("Cliente salvo.","success");
    } catch { toast("Não foi possível salvar. Tente novamente.","error"); } finally { setSaving(false); }
  };

  const edit = (c) => {
    setForm({ nome:c.nome||"", celular:c.celular||"", instagram:c.instagram?`@${c.instagram}`:"", aniversario:c.aniversario||"", aceitaWhatsapp:!!c.aceitaWhatsapp, tipo:c.tipo||"" });
    setEditId(c.id); setFormOpen(true);
  };
  const del = async (c) => {
    if (!await confirmar(`Excluir o cliente "${c.nome || "selecionado"}" e todos os dados dele (nome, e-mail, telefone, nascimento)? Esta ação não pode ser desfeita.`)) return;
    // Cliente vindo da loja: apaga também o cadastro online (clientes_finais),
    // senão ele volta no próximo espelhamento.
    if (c.clienteFinalId) {
      try {
        const cur = getUser();
        if (cur?.uid) await deleteDoc(doc(db, `users/${cur.uid}/clientes_finais/${c.clienteFinalId}`));
      } catch (e) { console.error("Erro ao excluir cadastro da loja:", e); }
    }
    await fbDelete("clientes", c.id);
    carregar();
  };

  const abrirMsg = (c, textoInicial = "") => {
    setMsgModal(c);
    setMsgTexto(textoInicial);
    setTemplateSel("");
    setErroMsg("");
    setOkMsg(false);
  };

  const aplicarTemplate = (templateId) => {
    if (!templateId || !msgModal) return;
    const tpl = TEMPLATES.find(t => t.id === templateId);
    if (tpl) setMsgTexto(tpl.msg.replace(/\{nome\}/g, msgModal.nome));
    setTemplateSel(templateId);
  };

  const enviarMensagem = async () => {
    if (!msgTexto.trim()) return;
    setEnviando(true); setErroMsg("");
    try {
      const numero = msgModal.celular.replace(/\D/g, "");
      const url = `https://wa.me/55${numero}?text=${encodeURIComponent(msgTexto)}`;
      window.open(url, "_blank");
      await fbUpdate("clientes", msgModal.id, { ultimoContato: new Date().toISOString() });
      setOkMsg(true);
      setTimeout(() => { setMsgModal(null); setMsgTexto(""); setOkMsg(false); carregar(); }, 1500);
    } catch(e) { setErroMsg(e.message || "Erro ao abrir WhatsApp"); }
    setEnviando(false);
  };

  const filtrados = data.filter(c => (tipoFiltro === "Todos" || c.tipo === tipoFiltro) && [c.nome,c.celular,c.instagram].join(" ").toLowerCase().includes(busca.toLowerCase().trim()));

  const fecharForm = () => { setFormOpen(false); setEditId(null); setForm(empty); };
  const field = key => ({value:form[key],onChange:e=>setForm({...form,[key]:e.target.value})});
  return <div className="tool-module tool-module--clientes">
    {modalConfirm}
    <ToolSummary items={[{label:"Clientes",value:loading?"—":data.length},{label:"Aceitam WhatsApp",value:data.filter(c=>c.aceitaWhatsapp).length},{label:"Clientes VIP",value:data.filter(c=>c.tipo==="VIP").length}]} />
    <ToolSearch value={busca} onChange={setBusca} placeholder="Buscar nome, celular ou Instagram"><ToolButton onClick={()=>{setEditId(null);setForm(empty);setFormOpen(true);}}>+ Novo cliente</ToolButton></ToolSearch>
    <ToolFilters options={["Todos",...Object.keys(TIPO_CORES)]} value={tipoFiltro} onChange={setTipoFiltro} />
    <div className="tool-item-grid">
      {loading?<ToolEmpty icon="clientes" title="Carregando clientes…" />:!filtrados.length?<ToolEmpty icon="clientes" title={data.length?"Nenhum cliente encontrado":"Conheça quem compra suas ideias"}>Cadastre seus clientes e tenha os contatos sempre à mão.</ToolEmpty>:filtrados.map(c=><article className={"tool-item"+(deeplinkClienteId===c.id?" tool-item--highlight":"")} key={c.id}>
        <div className="tool-item-top"><span className="tool-item-mark">{(c.nome||"C").slice(0,1).toUpperCase()}</span><div className="tool-item-copy"><h3>{c.nome}</h3><p>{c.celular||"Celular não informado"}</p>{c.tipo&&<span className="tool-status">{c.tipo}</span>}</div></div>
        <div className="tool-contact-details">{c.aniversario&&<p>Aniversário · {c.aniversario}</p>}{linkInstagram(c.instagram)&&<a href={linkInstagram(c.instagram)} target="_blank" rel="noopener noreferrer">@{limparInstagram(c.instagram)} ↗</a>}<p>{c.aceitaWhatsapp?"Aceita mensagens promocionais":"Sem autorização para promoções"}</p>{diasAtras(c.ultimoContato)!==null&&<p>Último contato: {diasAtras(c.ultimoContato)===0?"hoje":diasAtras(c.ultimoContato)+" dias atrás"}</p>}</div>
        <div className="tool-actions">{c.aceitaWhatsapp&&<ToolButton secondary onClick={()=>abrirMsg(c,"")}>WhatsApp</ToolButton>}<ToolButton secondary onClick={()=>edit(c)}>Editar</ToolButton><ToolButton danger aria-label={"Excluir "+c.nome} onClick={()=>del(c)}>Excluir</ToolButton></div>
      </article>)}
    </div>
    {formOpen&&<ToolDialog compact title={editId?"Editar cliente":"Novo cliente"} subtitle="Um bom relacionamento começa com os dados certos." icon="clientes" color="#72de99" onClose={fecharForm} busy={saving}>
      <div className="tool-form-grid"><Inp label="Nome *" {...field("nome")} placeholder="Nome do cliente" /><Inp label="Celular *" type="tel" inputMode="tel" value={form.celular} onChange={e=>setForm({...form,celular:fmtCel(e.target.value)})} placeholder="(99) 99999-9999" /><Inp label="Instagram" {...field("instagram")} placeholder="@usuario" /><Inp label="Aniversário (DD/MM)" inputMode="numeric" value={form.aniversario} onChange={e=>setForm({...form,aniversario:fmtAniv(e.target.value)})} placeholder="15/07" /><Sel label="Tipo de cliente" {...field("tipo")}><option value="">Não definido</option>{Object.keys(TIPO_CORES).map(tipo=><option key={tipo}>{tipo}</option>)}</Sel><label className="tool-check"><input type="checkbox" checked={form.aceitaWhatsapp} onChange={e=>setForm({...form,aceitaWhatsapp:e.target.checked})} /> Aceita promoções por WhatsApp</label></div>
      <div className="tool-actions"><ToolButton onClick={save} disabled={saving}>{saving?"Salvando…":"Salvar cliente"}</ToolButton><ToolButton secondary onClick={fecharForm} disabled={saving}>Cancelar</ToolButton></div>
    </ToolDialog>}
    {msgModal&&<ToolDialog compact title="Conversar pelo WhatsApp" subtitle={msgModal.nome+" · "+msgModal.celular} icon="clientes" color="#72de99" onClose={()=>setMsgModal(null)} busy={enviando}>
      <div className="tool-form-grid"><div className="tool-field-wide"><Sel label="Modelo de mensagem" value={templateSel} onChange={e=>aplicarTemplate(e.target.value)}><option value="">Escrever minha mensagem</option>{TEMPLATES.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}</Sel></div><label className="tool-textarea-label tool-field-wide">Mensagem<textarea value={msgTexto} onChange={e=>setMsgTexto(e.target.value)} placeholder="Digite sua mensagem…" rows={6} /></label></div>
      <p className="tool-note">O WhatsApp será aberto com o texto pronto. Confira a conversa e envie por lá.</p>
      {erroMsg&&<p role="alert" className="tool-stock-warning">{erroMsg}</p>}{okMsg&&<p role="status">WhatsApp aberto. Finalize o envio na conversa.</p>}
      <div className="tool-actions"><ToolButton onClick={enviarMensagem} disabled={enviando||okMsg||!msgTexto.trim()}>{enviando?"Abrindo…":"Abrir WhatsApp"}</ToolButton><ToolButton secondary onClick={()=>setMsgModal(null)}>Cancelar</ToolButton></div>
    </ToolDialog>}
  </div>;
}
